/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_No_ResultsInputs */

const en_directory_search_no_results = /** @type {(inputs: Directory_Search_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tools found`)
};

const zh_directory_search_no_results = /** @type {(inputs: Directory_Search_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有找到相关工具`)
};

/**
* | output |
* | --- |
* | "No tools found" |
*
* @param {Directory_Search_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_search_no_results = /** @type {((inputs?: Directory_Search_No_ResultsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_No_ResultsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_search_no_results(inputs)
	return zh_directory_search_no_results(inputs)
});
export { directory_search_no_results as "directory.search.no_results" }